import React from 'react';
import BoxTitleWrapper from './boxTitle';
import { BoxWrapper } from './box.style';
import withLoader from "../LoadingContainer"

const box = props => (
  <BoxWrapper
    className={`${props.className} isoBoxWrapper`}
    style={props.style}
  >
    <BoxTitleWrapper title={props.title} subtitle={props.subtitle} />
    {props.children}
  </BoxWrapper>
);

export default withLoader(box);



// WEBPACK FOOTER //
// ./src/components/ui-ant/utility/box.js